"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const polished_1 = require("polished");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const IconBadge = ({ icon }) => {
    return (0, jsx_runtime_1.jsx)(StyledIconBadge, { children: icon });
};
exports.IconBadge = IconBadge;
const StyledIconBadge = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: center;
	width: 3rem;
	height: 3rem;
	border-radius: 50%;
	background-color: ${({ theme }) => (0, polished_1.transparentize)(0.9, theme.color.brand1)};
	svg {
		width: 1.25rem;
		height: 1.25rem;
		fill: ${({ theme }) => theme.color.brand1};
	}
`;
